var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { RoutePath, generateRoutePath } from '../../app/router/config';
import { parseChangelogItemTitle } from '../../utils/changelog';
import { useInput } from '../common/use-input';
var PATCH_NOTE_URL = 'https://raw.githubusercontent.com/crosstheages/tcg-public-tracker/main/patch-notes.md';
export function useChangelog(tab) {
    var location = useLocation();
    var navigate = useNavigate();
    var _a = useState([]), items = _a[0], setItems = _a[1];
    var _b = useState(undefined), selectedItemTitle = _b[0], setSelectedItemTitle = _b[1];
    var _c = useState(false), initialized = _c[0], setInitialized = _c[1];
    var searchQuery = useInput('');
    useEffect(function () {
        function scrollToAnchor() {
            var target = window.document.querySelector("#changelog-".concat(location.hash.split('#')[1]));
            target === null || target === void 0 ? void 0 : target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            target === null || target === void 0 ? void 0 : target.scroll();
            return Boolean(target);
        }
        if (location.hash && items[0] && (initialized || location.hash !== "#".concat(parseChangelogItemTitle(items[0].title)))) {
            scrollToAnchor();
        }
        setInitialized(Boolean(items[0] && location.hash));
    }, [location.hash, items]);
    useEffect(function () {
        if (selectedItemTitle !== undefined) {
            navigate("".concat(generateRoutePath(RoutePath.CHANGELOG, { tab: tab }), "/#").concat(selectedItemTitle));
        }
    }, [selectedItemTitle, tab, navigate]);
    useEffect(function () {
        function parseMD(md) {
            var rows = md.split('\n');
            var i = 0;
            rows = rows.filter(function (value) { return value.length > 0; });
            if (rows.length === 0)
                return;
            // Skip the title
            while (i < rows.length && !rows[i].startsWith('## ')) {
                i += 1;
            }
            i += 1;
            // Skip the direct links
            if (i < rows.length) {
                while (i < rows.length && !rows[i].startsWith('## ')) {
                    i += 1;
                }
            }
            rows.splice(0, i);
            parsePatches(rows);
        }
        function parsePatches(rows) {
            var patches = [];
            var i = 0;
            while (i < rows.length) {
                var patchRows = [];
                var date = '';
                var j = 0;
                if (i < rows.length + 1) {
                    date = rows[i + 1].slice(0, Math.max(0, rows[i + 1].length - 1)).slice(1);
                }
                var patch = {
                    title: rows[i].slice(3),
                    date: date,
                    content: '',
                };
                i += 1;
                while (i < rows.length && !rows[i].startsWith('## ')) {
                    if (j > 0)
                        patchRows.push(rows[i]);
                    i += 1;
                    j += 1;
                }
                patch.content = rowsToString(patchRows);
                patches.push(patch);
            }
            setItems(patches);
        }
        function readMD() {
            return __awaiter(this, void 0, void 0, function () {
                var response, md;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, fetch(PATCH_NOTE_URL)];
                        case 1:
                            response = _a.sent();
                            return [4 /*yield*/, response.text()];
                        case 2:
                            md = _a.sent();
                            parseMD(md);
                            return [2 /*return*/];
                    }
                });
            });
        }
        readMD();
    }, [location.hash]);
    useEffect(function () {
        if (!items || items.length === 0 || !items[0].title) {
            setSelectedItemTitle(undefined);
        }
        else {
            setSelectedItemTitle(location.hash.length > 1 ? location.hash.substring(1) : parseChangelogItemTitle(items[0].title));
        }
    }, [location.hash, items]);
    function rowsToString(rows) {
        var result = '';
        for (var _i = 0, rows_1 = rows; _i < rows_1.length; _i++) {
            var str = rows_1[_i];
            result += "".concat(str, "\n");
        }
        result.slice(-1, 1);
        return result;
    }
    return {
        items: items,
        selectedItemTitle: selectedItemTitle,
        setSelectedItemTitle: setSelectedItemTitle,
        searchQuery: searchQuery,
    };
}
